import { Form, Input } from "antd";
import { FormInstance } from "antd/lib/form";
import RetailText from "components/Typography/RetailText";
import RetailFormInput from "components/Form/RetailFormInput";
import CampaignDetailsModal from "components/Modal/CampaignDetailsModal";
import { ReactComponent as AlertFilled } from "assets/icons/alertFilled.svg";
import { useTranslation } from "react-i18next";
import { REDIRECT_URL_REGEX } from "utils/constants";
import cc from "classcat";
import cm from "../style.module.scss";

interface CampaignDetailsRedirectUrlProps {
  form: FormInstance<any>;
  redirectUrlStates: {
    visible: boolean;
    url: string;
  };
  onRedirectUrlCancel: () => void;
  onRedirectUrlOk: () => void;
  isRedirectUrlUpdating: boolean;
  handleRedirectUrlChange: ({
    target,
  }: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const CampaignDetailsRedirectUrl = ({
  form,
  redirectUrlStates,
  onRedirectUrlCancel,
  onRedirectUrlOk,
  isRedirectUrlUpdating,
  handleRedirectUrlChange,
}: CampaignDetailsRedirectUrlProps) => {
  const { t } = useTranslation();

  return (
    <CampaignDetailsModal
      type="UPDATE_REDIRECT_URL"
      subtitle={t("pages.acc.campaignDetails.updateRedirectUrl")}
      visible={redirectUrlStates.visible}
      onOk={form.submit}
      onCancel={onRedirectUrlCancel}
      disabled={redirectUrlStates.url === "" || isRedirectUrlUpdating}
    >
      <Form
        form={form}
        requiredMark={false}
        autoComplete="off"
        onFinish={onRedirectUrlOk}
      >
        <div className={cm.redirectUrlContainer}>
          <AlertFilled />
          <RetailText size="xxxs" weight="medium">
            {t("pages.acc.campaignDetails.redirectUrlWarning")}
          </RetailText>
        </div>
        <RetailFormInput
          isFocused={redirectUrlStates.url !== ""}
          name="url"
          label={t("components.campaignForm.firstStep.urlTitle")}
          rules={[
            {
              required: true,
              message: t("components.campaignForm.firstStep.urlError"),
              pattern: REDIRECT_URL_REGEX,
            },
          ]}
          className="floating"
        >
          <Input.TextArea
            className={cc(["floating", cm.textarea])}
            onChange={handleRedirectUrlChange}
            name="redirect_url"
          />
        </RetailFormInput>
      </Form>
    </CampaignDetailsModal>
  );
};

export default CampaignDetailsRedirectUrl;
